import { useMemo } from "react";
import { deleteVersionIsDisabled } from "../../utilities/utilities";

export function useVersionTableState({
	documentList,
	userRights,
	documentLifecycleStatusObject,
	ableToModify,
	documentNotInUse,
}) {
	const maxVersionNumber = useMemo(
		() => Math.max(...documentList.map((d) => d.versionNumber), 0),
		[documentList]
	);

	const deleteDisabledInfo = useMemo(
		() =>
			deleteVersionIsDisabled({
				userRights,
				documentActionsAreDisabled:
					documentLifecycleStatusObject.disabled,
				documentActionsAreDisabledHoverText:
					documentLifecycleStatusObject.disabledText,
			}),
		[userRights, documentLifecycleStatusObject]
	);

	const promotionDisabledInfo = useMemo(() => {
		if (!documentNotInUse) {
			return {
				disabled: true,
				disabledHoverText: ableToModify
					? "Cannot promote while the document is open"
					: "Cannot promote while the document is locked by another user",
			};
		}
		if (!ableToModify) {
			return {
				disabled: true,
				disabledHoverText:
					"Cannot promote while the document is locked by another user",
			};
		}
		return { disabled: false, disabledHoverText: "" };
	}, [documentNotInUse, ableToModify]);

	return { maxVersionNumber, deleteDisabledInfo, promotionDisabledInfo };
}
